import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { RootState } from '../../../redux/store';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import { KTIcon } from '../../../_metronic/helpers/components/KTIcon';
import Content from '../../../_metronic/layout/components/content/Content';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator, storeAreYouSureModalCallback, storeImageViewer } from '../../../redux/reducers/authSlice';
import { LandOrderService } from '../../../services/LandOrderService';
import { GetLandOrderListPagingAndFilterRequest, initialGetLandOrderListPagingAndFilterRequest } from '../../../models/request/landOrder/GetLandOrderListPagingAndFilterRequest';
import TableFooter from '../../../components/TableFooter';
import { GetLandOrderListPagingAndFilterResponse, GetLandOrderListPagingAndFilterResponseData, GetLandOrderListPagingAndFilterResponseItem, initialGetLandOrderListPagingAndFilterResponseData } from '../../../models/response/landOrder/GetLandOrderListPagingAndFilterResponse';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { GetCompanyListResponse, GetCompanyListResponseItem } from '../../../models/response/company/GetCompanyListResponse';
import { CompanyService } from '../../../services/CompanyService';
import { CustomSingleSelectModel } from '../../../components/CustomSingleSelect';
import { GetConstantListResponse } from '../../../models/response/constant/GetConstantListResponse';
import { ConstantService } from '../../../services/ConstantService';
import LandOrderListFilters from './Components/LandOrderListFilters';
import { ExportLandOrderListResponse } from '../../../models/response/landOrder/ExportLandOrderListResponse';
import { DeleteLandOrderResponse } from '../../../models/response/landOrder/DeleteLandOrderResponse';
import { CustomMultiSelectModel } from '../../../components/CustomMultiSelect';
import { GetVehicleListResponse } from '../../../models/response/vehicle/GetVehicleListResponse';
import { VehicleService } from '../../../services/VehicleService';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { loadConstants, loadList } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import StatusBadge from '../../../components/StatusBadge';
import { DriverService } from '../../../services/DriverService';
import { CountryService } from '../../../services/CountryService';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';

const LandOrderList = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = "Uluslararası Kara > Siparişler"
    const pageVersion = "1";
    const [data, setData] = useState<GetLandOrderListPagingAndFilterResponseData>(initialGetLandOrderListPagingAndFilterResponseData);
    const [filter, setFilter] = useState<GetLandOrderListPagingAndFilterRequest>(initialGetLandOrderListPagingAndFilterRequest);

    const getColumns = () => {
        var list: ColumnChooserModel[] = [];

        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        list = [
            { title: 'Ref No', name: 'refNo', order: 0, isVisible: true },
            { title: 'Sipariş Tarihi', name: 'orderDateStr', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'customerName', order: 0, isVisible: true },
            { title: 'Gönderici', name: 'senderFirmName', order: 0, isVisible: true },
            { title: 'Alıcı', name: 'receiverFirmName', order: 0, isVisible: true },
            { title: 'Yükleme Ülkesi', name: 'loadingCountryName', order: 0, isVisible: true },
            { title: 'Yükleme Şehri', name: 'loadingCountyName', order: 0, isVisible: true },
            { title: 'Teslim Ülkesi', name: 'unloadingCountryName', order: 0, isVisible: true },
            { title: 'Teslim Şehri', name: 'unloadingCountyName', order: 0, isVisible: true },
            { title: 'Yükleme Tarihi', name: 'loadingDateStr', order: 0, isVisible: true },
            { title: 'Teslim Tarihi', name: 'deliverDateStr', order: 0, isVisible: true },
            { title: 'Sipariş Durumu', name: 'orderStatusName', order: 0, isVisible: true },
            { title: 'Operasyon Türü', name: 'operationTypeName', order: 0, isVisible: true },
            { title: 'Araç Plaka', name: 'vehicleName', order: 0, isVisible: true },
            { title: 'Treyler Plaka', name: 'trailerName', order: 0, isVisible: true },
            { title: 'Sürücü', name: 'driverName', order: 0, isVisible: true },
            { title: 'Tedarikçi', name: 'supplierName', order: 0, isVisible: true },
            { title: 'Toplam Miktar', name: 'totalQuantity', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Ağırlık', name: 'totalWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Desi', name: 'totalDesi', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Hacim', name: 'totalVolume', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Toplam Ücret Ağırlığı', name: 'totalPriceWeight', order: 0, isVisible: true, className: 'custom-text-right' },
            { title: 'Oluşturan', name: 'createdUser', order: 0, isVisible: true },
            { title: 'Güncelleyen', name: 'updatedUser', order: 0, isVisible: true }
        ];

        for (var i = 0; i < list.length; i++) {
            list[i].order = i + 1;
        }

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => {
        getData({
            ...filter,
            currentPage: i,
            skip: (i - 1) * filter.take
        });
    }

    const changeTake = (_take: number) => {
        getData({
            ...filter,
            currentPage: 1,
            skip: 0,
            take: _take
        });
    }

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    const deleteLandOrder = async () => {
        try {
            var selectedIds = data.items.filter(x => x.isSelected).map(x => x.landOrderId);

            dispatch(storeActivityIndicator(true))

            var response: DeleteLandOrderResponse = await LandOrderService.deleteLandOrder(selectedIds);

            if (!response.isSuccess) {
                toast.error(response.message)
                dispatch(storeActivityIndicator(false))
                return;
            }

            toast.success(response.message)

            getData();
        } catch (error: any) {
            toast.error(error)
            dispatch(storeActivityIndicator(false))
        }
    }

    const updateLandOrder = async (_id: string | undefined = undefined) => {
        navigate('/landorder/listadd?id=' + (_id ? _id : data.items.filter(x => x.isSelected)[0].landOrderId));
    }

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: GetLandOrderListPagingAndFilterRequest | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true));

            var response: GetLandOrderListPagingAndFilterResponse = await LandOrderService.getLandOrderListPagingAndFilter(_filter);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            // Daha yeni bir istek sürüyorsa yükleniyor göstergesi açık kalır.
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            items: data.items.map(function (x) {
                if (x.landOrderId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.items.length == data.items.filter(x => x.isSelected).length;

        setData({
            ...data,
            items: data.items.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const onSearchSubmit = (e: any) => {
        e.preventDefault()
        getData();
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response: ExportLandOrderListResponse = await LandOrderService.exportLandOrderList(buildExcelRequest(filter, mode, data.items.filter(x => x.isSelected).map(x => x.landOrderId), columns));

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Başlığa tıklayarak sıralanabilen kolonlar. Gönderici/alıcı ile yükleme ve
    // teslim ülke/şehir bilgileri adres kaydı üzerinden türetildiği, toplam
    // miktar/ağırlık/desi/hacim/ücret ağırlığı da sipariş kalemlerinden
    // hesaplandığı için sıralama dışında bırakıldı.
    const sortableColumns = [
        'refNo', 'orderDateStr', 'customerName', 'loadingDateStr', 'deliverDateStr',
        'orderStatusName', 'operationTypeName', 'vehicleName', 'trailerName',
        'driverName', 'supplierName', 'createdUser', 'updatedUser'
    ];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    // Kolon başlıklarının altındaki filtreler. Kolon adları backend'deki eşlemeyle
    // (LandOrderManager.ApplyColumnFilters) aynı. Seçim listeleri eski filtre panelindeki
    // listelerle aynı. Toplam kolonları sipariş kalemlerinden hesaplandığı için filtresiz.
    const columnFilterDefinitions: ColumnFilterDefinitions = {
        refNo: { type: 'text' },
        orderDateStr: { type: 'date' },
        customerName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isCustomer: true }), 'companyId', x => x.name) },
        senderFirmName: { type: 'text' },
        receiverFirmName: { type: 'text' },
        loadingCountryName: { type: 'select', loadOptions: () => loadList(CountryService.getCountryList(), 'countryId', x => x.name) },
        loadingCountyName: { type: 'text' },
        unloadingCountryName: { type: 'select', loadOptions: () => loadList(CountryService.getCountryList(), 'countryId', x => x.name) },
        unloadingCountyName: { type: 'text' },
        loadingDateStr: { type: 'date' },
        deliverDateStr: { type: 'date' },
        orderStatusName: { type: 'select', loadOptions: () => loadConstants('ORDER_STATUS'), renderOption: (label) => <StatusBadge text={label} /> },
        operationTypeName: { type: 'select', loadOptions: () => loadConstants('OPERATION_TYPE') },
        vehicleName: { type: 'select', loadOptions: () => loadList(VehicleService.getVehicleList(undefined, ["7"]), 'vehicleId', x => x.plate) },
        trailerName: { type: 'select', loadOptions: () => loadList(VehicleService.getVehicleList(["7"]), 'vehicleId', x => x.plate) },
        driverName: { type: 'select', loadOptions: () => loadList(DriverService.getDriverList(), 'driverId', x => x.nameSurname) },
        supplierName: { type: 'select', loadOptions: () => loadList(CompanyService.getCompanyList({ isSupplier: true }), 'companyId', x => x.name) },
        createdUser: { type: 'text' },
        updatedUser: { type: 'text' },
    };

    // Kolon filtresi değişince ilk sayfaya dönülür; sıralama ve sayfa boyu korunur.
    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: GetLandOrderListPagingAndFilterResponseItem, column: string, index: number, className: string | undefined) => {
        if (column == "createdUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.landOrderId)} onDoubleClick={() => updateLandOrder(item.landOrderId)}>{item.createdUser} - {item.createdDate}</td>
            )
        }
        else if (column == "updatedUser") {
            return (
                <td className={className} onClick={() => setItemSelected(item.landOrderId)} onDoubleClick={() => updateLandOrder(item.landOrderId)}>{item.updatedUser} - {item.updatedDate}</td>
            )
        }
        else if (column == "refNo") {
            return (
                <td className={className} onClick={() => setItemSelected(item.landOrderId)} onDoubleClick={() => updateLandOrder(item.landOrderId)}><a onClick={() => window.open(window.location.href + "add?id=" + item.landOrderId, "_blank")} href='javascript:;'>{item.refNo}</a></td>
            )
        }
        else if (column == "orderStatusName") {
            return (
                <td className={className} onClick={() => setItemSelected(item.landOrderId)} onDoubleClick={() => updateLandOrder(item.landOrderId)}><StatusBadge text={item.orderStatusName} /></td>
            )
        }
        else if (["totalQuantity", "totalWeight", "totalDesi", "totalVolume", "totalPriceWeight"].includes(column)) {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.landOrderId)} onDoubleClick={() => updateLandOrder(item.landOrderId)}>{Helpers.correctPrice(item2[column])}</td>;
        }
        else {
            var item2: any = item;
            return <td className={className} onClick={() => setItemSelected(item.landOrderId)} onDoubleClick={() => updateLandOrder(item.landOrderId)}>{item2[column]}</td>;
        }
    }

    // Dip toplam: görüntülenen sayfadaki kayıtların toplamı. Yalnızca sipariş
    // detaylarından gelen miktar/ağırlık/desi/hacim/ücret ağırlığı toplanır.
    const getTotalValue = (columnName: string, columnIndex: number, className: string | undefined) => {
        const totals = data.totals;

        if (columnIndex == 0) {
            return <td className={className}>Toplam</td>;
        }

        if (["totalQuantity", "totalWeight", "totalDesi", "totalVolume", "totalPriceWeight"].includes(columnName)) {
            var totals2: any = totals;
            return <td className={className}>{Helpers.correctPrice(totals2 ? totals2[columnName] : 0)}</td>;
        }

        return <td className={className}></td>;
    }

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />
                <LandOrderListFilters
                    columns={columns}
                    excelExport={excelExport}
                    filter={filter}
                    getColumns={getColumns}
                    getData={getData}
                    pageName={pageName}
                    pageVersion={pageVersion}
                    setColumns={setColumns}
                    setFilter={setFilter}
                    selectedCount={data.items.filter(x => x.isSelected).length}
                    deleteFunction={deleteLandOrder}
                    updateFunction={updateLandOrder}
                    onSearchSubmit={onSearchSubmit}
                />
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table ebbe-table-fill'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.items.filter(x => x.isSelected).length > 0 && data.items.filter(x => x.isSelected).length == data.items.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item, index) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.items.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.items.map((item, index) =>
                                            <tr style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.landOrderId)} className='form-check-input' type='checkbox' checked={item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getColumnValue(item, column.name, index, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }

                                    {
                                        /* Az kayıt geldiğinde kalan boşluğu doldurur; dip toplam satırı
                                           tablonun altına iner, çerçeve hep aynı yerde kalır. */
                                        data.items.length > 0 && (
                                            <tr className="ebbe-table-filler">
                                                <td colSpan={99}></td>
                                            </tr>
                                        )
                                    }
                                </tbody>

                                {
                                    data.items.length > 0 && (
                                        <tfoot>
                                            <tr>
                                                <td style={{ width: 1 }}></td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column, columnIndex) => (
                                                        <React.Fragment>{getTotalValue(column.name, columnIndex, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        </tfoot>
                                    )
                                }
                            </table>
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={data.items.filter(x => x.isSelected).length}
                    />
                </KTCard>
            </Content>
        </React.Fragment>
    )
}

export default LandOrderList;